'use client';

import { useStopClickPropagation } from '@/app/(main)/calendar/hooks/useStopClickPropagation';
import Checkbox from '@/app/components/Checkbox';

type CalendarDeadlineCheckboxProps = {
  checked: boolean;
  onToggle: () => void;
};

export function CalendarDeadlineCheckbox({ checked, onToggle }: CalendarDeadlineCheckboxProps) {
  const wrapperRef = useStopClickPropagation<HTMLSpanElement>(() => {
    onToggle();
  });

  return (
    <span
      ref={wrapperRef}
      className="sf-calendar-event__deadline-checkbox absolute inset-0 z-[1] flex items-center justify-center"
    >
      <Checkbox checked={checked} size="small" readOnly tabIndex={-1} />
    </span>
  );
}
